import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  FormFieldTypes,
  LoadingStatus,
  ToastThemes,
} from '../../../../constants/common';
import TryAgain from '../../../molecules/ErrorState/error.component';
import CircularLoader from '../../../../atoms/CircularLoader/circular-loader';
import TDSConfigFormEdit from './tds-config-form/tds-config-form-edit';
import TDSConfigFormView from './tds-config-form/tds-config-form-view';
import { GeoTagging } from '../../../../services/geoTagging';
import { showToast } from '../../../../utils/common.util';

const AddTdsConfig = () => {
  const { currentUserRoleId, appPermissions } = useSelector(
    (state) => state.main
  );
  const { compBenPermission } = useSelector((state) => state.modulePermissions);

  const location = useLocation();
  const pathNames = location.pathname.split('/');
  const idForDetails = pathNames[pathNames.length - 1];
  const [viewMode, setViewMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(-1);
  const [formInfo, setFormInfo] = useState({});

  const fieldsForConfig = [
    {
      id: 1,
      fieldLabel: 'PAN Number',
      placeholderText: 'Type Here',
      fieldType: FormFieldTypes.Text,
      isRequired: true,
      isHidden: false,
      fieldRefName: 'panNumber',
      size: 'small',
      fullWidth: true,
      fieldSize: 6,
      toUpperCase: true,
    },
    {
      id: 1,
      fieldLabel: 'Is New Tax Regime',
      placeholderText: 'Type Here',
      fieldType: FormFieldTypes.CheckBox,
      fieldRefName: 'isNewTaxRegime',
    },
  ];

  useEffect(async () => {
    if (currentUserRoleId) {
      if (idForDetails) {
        setLoading(LoadingStatus.Loading);
        await new GeoTagging()
          .tdsConfigDetails(idForDetails)
          .then((res) => {
            setFormData(res);
            setLoading(LoadingStatus.Success);
            setViewMode(true);
          })
          .catch((err) => {
            showToast(err?.response?.data?.message, ToastThemes.error);
            setLoading(LoadingStatus.Failure);
            throw err?.response?.data?.message;
          });
      }
    }
    return () => {
      setViewMode(false);
    };
  }, [idForDetails, currentUserRoleId]);

  useEffect(() => {
    setFormInfo(formData);
  }, [formData]);

  if (loading === LoadingStatus.Failure) {
    return <TryAgain />;
  }
  return (
    <>
      <CircularLoader show={loading === LoadingStatus.Loading} />
      {loading === LoadingStatus.Success && viewMode ? (
        <TDSConfigFormView
          formConfig={fieldsForConfig}
          setViewMode={setViewMode}
          isNew={!idForDetails}
          formData={formInfo}
        />
      ) : (
        <TDSConfigFormEdit
          formConfig={fieldsForConfig}
          setViewMode={setViewMode}
          formData={formData}
          isNew={!idForDetails}
          formInfo={formInfo}
          setFormInfo={setFormInfo}
          idForDetails={idForDetails}
        />
      )}
    </>
  );
};

export default AddTdsConfig;
